import React from "react";
import Layout from "../components/layout";
import SEO from "../components/seo";
import Fastrope from "../cases/Fastrope/fastrope"

const FastropeLabs = () => (
    <Layout>
        <SEO title="Fastrope | Ryan Luu" />
        <Fastrope />
    </Layout>
)

export default FastropeLabs